// Themes
export const THEMES = {
    FINANCE_LAB: 'FINANCE_LAB',
    DEFAULT: 'DEFAULT',
    DARK: 'DARK',
    LIGHT: 'LIGHT',
    BLUE: 'BLUE',
    GREEN: 'GREEN',
    INDIGO: 'INDIGO',
}

export const DEPLOY_INFO_TIME = import.meta.env.VITE_DEPLOY_INFO_TIME
export const DEPLOY_INFO_BRANCH_NAME = import.meta.env.VITE_DEPLOY_INFO_BRANCH_NAME
